import React from 'react';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

export const getClienteColumns = (onSelect) => [
  {
    id: 'nome',
    accessorKey: 'Nome',
    header: 'Nome',
    size: 300,
    cell: ({ row }) => {
      const nome = row.original.Nome || row.original.nome || '-';
      return (
        <div style={{ fontWeight: '500' }}>
          {nome}
        </div>
      );
    },
  },
  {
    id: 'cnpj',
    accessorKey: 'CNPJ',
    header: 'CNPJ',
    size: 180,
    cell: ({ row }) => {
      const cnpj = row.original.CNPJ || row.original.cnpj;
      if (!cnpj) return '-';
      const formatted = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
      return (
        <div style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}>
          {formatted}
        </div>
      );
    },
  },
  {
    id: 'acoes',
    header: 'Selecionar',
    size: 120,
    cell: ({ row }) => (
      <Button
        variant="primary"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          onSelect(row.original);
        }}
      >
        <Icon name="check" size={16} />
        Selecionar
      </Button>
    ),
    enableSorting: false,
  },
];
